import { BASE_URL } from "@/constants/config";
import { request } from "@/utils/request";

export const SPECIALITE_FORMATION_ENDPOINTS = {
  base: `${BASE_URL}api/specialite-formation/`,
  detail: (id) => `${SPECIALITE_FORMATION_ENDPOINTS.base}${id}/`,
};

class SpecialiteFormation {
  endpoints = SPECIALITE_FORMATION_ENDPOINTS;

  create(payload) {
    return request({
      url: this.endpoints.base,
      method: "POST",
      body: payload,
    });
  }

  update(payload) {
    return request({
      url: this.endpoints.detail(payload._id),
      method: "PUT",
      body: payload,
    });
  }

  delete(id) {
    return request({
      url: this.endpoints.detail(id),
      method: "DELETE",
    });
  }

  async block(ids) {
    return await request({
      url: this.endpoints.base,
      body: ids,
      method: 'DELETE',
    });
  }
}

export const SpecialiteFormationService = new SpecialiteFormation();
